import { Transforms } from 'slate';

const withBlockquote = editor => {
	const { insertBreak } = editor;

	// Handle's break event in blockquote
	editor.insertBreak = (args) => {
		// Proceed with default break insert
		if (!editor.isElementActive('blockquote')) return insertBreak(args);
		
		// Split blockquote
		Transforms.splitNodes(editor, { always: true });

		// Set splitted block to paragraph
		return Transforms.setNodes(editor, { type: 'paragraph' });
	};

	// Toggle given align on selection
	editor.toggleBlockquote = () => {
		Transforms.setNodes(editor, {
			type: editor.isElementActive('blockquote')
				? 'paragraph'
				: 'blockquote'
		});
	};

	return editor;
};

export default withBlockquote;